module.exports = __webpack_public_path__ + "static/media/title4.6cdf93a5.png";